
import React from 'react';
import { ApparelProduct } from '@/types';
import ApparelProductCard from '../../ApparelProductCard';

interface ProductGridProps {
  products: ApparelProduct[];
  onProductSelect: (product: ApparelProduct) => void;
}

export const ProductGrid = ({ products, onProductSelect }: ProductGridProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {products?.map((product) => (
        <ApparelProductCard
          key={product.id}
          product={product}
          onSelect={onProductSelect}
        />
      ))}
    </div>
  );
};

